export default {"src":"/coding-school/_next/static/media/Logo-white.ee047c7c.svg","height":24,"width":49,"blurWidth":0,"blurHeight":0};